import Icon from '../../components/Icon.vue'

Icon.register({"regular/images":{"width":576,"height":512,"paths":[{"d":"M480 416V432C480 458.5 458.5 480 432 480H48C21.5 480 0 458.5 0 432V176C0 149.5 21.5 128 48 128H64V176H54A6-6 0 0 1 48 182V426A6-6 0 0 1 54 432H426A6-6 0 0 1 432 426V416H480zM522 80H150A6-6 0 0 1 144 86V330A6-6 0 0 1 150 336H522A6-6 0 0 1 528 330V86A6-6 0 0 1 522 80zM528 32C554.5 32 576 53.5 576 80V336C576 362.5 554.5 384 528 384H144C117.5 384 96 362.5 96 336V80C96 53.5 117.5 32 144 32H528zM264 144C264 166.1 246.1 184 224 184S184 166.1 184 144 201.9 104 224 104 264 121.9 264 144zM192 240L231.5 200.5C236.2 195.8 243.8 195.8 248.5 200.5L288 240 391.5 136.5C396.2 131.8 403.8 131.8 408.5 136.5L480 208V288H192V240z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/images.js
// module id = null
// module chunks = 